import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../utils/translations';
import { motion } from 'framer-motion';
import LanguageSwitcher from './LanguageSwitcher';
import logo from '../assets/logo.jpeg';

const AjrakPattern = () => (
  <div style={{
    height: 4,
    background: 'linear-gradient(90deg, var(--sindhi-maroon) 0%, var(--sindhi-gold) 50%, var(--sindhi-navy) 100%)'
  }} />
);

export default function Navbar() {
  const { user, logout } = useAuth();
  const { language } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: '/',          label: t('home', language) },
    { to: '/about',     label: t('about', language) },
    { to: '/branches',  label: t('branches', language) },
    { to: '/books',     label: t('books', language) },
    { to: '/board',     label: t('board', language) },
    { to: '/events',    label: t('events', language) },
    { to: '/qanoon',    label: t('qanoon', language) },
    { to: '/contact',   label: t('contact', language) },
  ];

  return (
      <nav className="public-navbar" style={{ 
        background: 'rgba(10, 25, 47, 0.9)', 
        backdropFilter: 'blur(24px) saturate(160%)',
        borderBottom: '2px solid var(--sindhi-gold)',
        padding: '0 4rem',
        height: '80px',
        boxShadow: '0 10px 30px -10px rgba(0,0,0,0.5)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0 }}>
          <AjrakPattern />
        </div>
        {/* Logo */}
        <Link to="/" style={{ display:'flex', alignItems:'center', gap:16, textDecoration:'none' }}>
          <img src={logo} alt="SAS Sindh Logo" style={{
            width: 56,
            height: 56,
            borderRadius: 14,
            objectFit: 'cover',
            border: '2px solid var(--sindhi-gold)',
            boxShadow: '0 8px 16px rgba(0,0,0,0.3)'
          }} />
        </Link>

        {/* Desktop links */}
        <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'nowrap' }}>
          {links.map(l => (
            <Link key={l.to} to={l.to} className="nav-link"
              style={{ 
                color: location.pathname === l.to ? 'var(--sindhi-gold)' : 'var(--sindhi-gold)',
                background: location.pathname === l.to ? 'rgba(212, 175, 55, 0.1)' : 'transparent',
                fontWeight: location.pathname === l.to ? 800 : 600,
                padding: '8px 16px',
                borderRadius: 12,
                position: 'relative'
              }}>
              {l.label}
              {location.pathname === l.to && (
                <motion.div layoutId="navline" style={{ position:'absolute', bottom: -12, left: '20%', right: '20%', height: 3, background: 'var(--sindhi-gold)', borderRadius: '4px 4px 0 0' }} />
              )}
            </Link>
          ))}
        </div>

        {/* Auth buttons */}
        <div style={{ display:'flex', gap:16, flexShrink:0, alignItems:'center' }}>
          <LanguageSwitcher />
          {user ? (
            <>
              <button className="btn btn-gold" style={{ padding: '10px 20px', borderRadius: 12, fontSize: 13, fontWeight: 800 }}
                onClick={() => navigate('/admin')}>
                {t('admin', language)}
              </button>
              <button className="btn btn-outline"
                style={{ borderColor:'rgba(255,255,255,0.3)', color:'white', padding: '10px 20px', borderRadius: 12, fontSize: 13, fontWeight: 800 }}
                onClick={logout}>
                {t('logout', language)}
              </button>
            </>
          ) : (
            <>
              <Link to="/login" 
                style={{ color:'white', textDecoration: 'none', fontWeight: 700, fontSize: 14 }}>{t('login', language)}</Link>
              <Link to="/register" className="btn-premium" style={{ padding: '12px 24px', borderRadius: 12, fontSize: 13 }}>{t('register', language)}</Link>
            </>
          )}
        </div>
      </nav>
    );
}
